import {CHAT_BASE_PATH} from '@root/common/chatBasePath';
import {BrandBase} from '../BrandBase';
import {createMicrositeTheme} from '../MicrositeTheme';

const CHAT_BASE_PATH_WITH_SLASH = `${CHAT_BASE_PATH}/` as const;

export const chatCoffeeBase: BrandBase = {
  id: `chatCoffee`,
  domain: `chatcoffee.net`,
  email: `support@chatcoffee.net`,
  theme: `deepBlue`,
  backgroundId: `cozy`,
  adsenseId: `ca-pub-9538741713677659`,
  micrositeTheme: createMicrositeTheme({
    id: `chatCoffee`,
    name: `Chat Coffee Microsite`,
    palette: {
      primary: `#951c37`,
      secondary: `#374151`,
      accent: `#f97316`,
    },
    gradients: {
      hero: `linear-gradient(135deg, #374151, #951c37)`,
      sectionLight: `linear-gradient(135deg, rgba(255, 248, 244, 0.98), rgba(238, 242, 255, 0.92))`,
      sectionDark: `linear-gradient(160deg, #0b0f19, #111827 45%, #05080f 90%)`,
      primaryCta: `linear-gradient(120deg, #f97316 0%, #ef4444 45%, #fbbf24 100%)`,
    },
    ctas: {
      primary: {
        background: `linear-gradient(120deg, #f97316 0%, #ef4444 45%, #fbbf24 100%)`,
        glow: `rgba(249, 115, 22, 0.45)`,
        shadow: `0 32px 70px rgba(249, 115, 22, 0.4)`,
      },
    },
  }),
  manifest: {
    name: `Chat Coffee - Sexting | Anonymous Chat Rooms | No Registration Required`,
    short_name: `Chat Coffee`,
    description: `Sexting, Anonymous chat rooms, No registration required. Free private messaging with complete anonymity & encryption.`,
    theme_color: `#000000`,
    background_color: `#000000`,
    display: `standalone`,
    orientation: `portrait`,
    scope: CHAT_BASE_PATH_WITH_SLASH,
    start_url: CHAT_BASE_PATH_WITH_SLASH,
    icons: [],
  },
  canonical: {
    prod: `https://chatcoffee.net`,
    uat: `https://dev.chatcoffee.net`,
    local: `http://localhost:5173`,
    localdev: `http://localhost:5173`,
    localnative: `http://localhost:5173`,
  },
  hostRedirects: {
    'www.chatcoffee.net': `chatcoffee.net`,
  },
  favicon: `/logo-square.png`,
  seo: {
    keywords: `anonymous chat, no registration chat, private messaging, free chat rooms, instant chat, no signup, Chat Coffee`,
    author: `Chat Coffee`,
  },
  social: {
    title: `Chat Coffee - Anonymous Chat Rooms | No Registration Required`,
    image: `/icon.png`,
  },
};
